<template>
  <div class="threesixty">
    <header-box class="threesixty__header" :title="title" :long="true"></header-box>
    <div class="threesixty__innerwrap">
      <div class="threesixty__blocks">

        <div class="threesixty__block threesixty__block--title">
          <h1 class="threesixty__title" v-html="title"></h1>
        </div>

        <div class="threesixty__block"
          :id="'block-' + block.id"
          v-for="block in contentBlocks"
          :class="{opaque: (selectedBullet !== -1 && selectedBullet !== block.id)}"
          v-if="(selectedBullet !== -1 && selectedBullet == block.id) || isNotTablet || isLandscape || selectedBullet === -1"
        >
          <div class="threesixty__block-image-wrapper" v-if="block.image">
            <movie-player class="threesixty__block-video" v-if="block.video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img class="threesixty__block-image" v-if="!block.video" :src="block.image" />
          </div>
          <div class="threesixty__block-textwrap" @click="goToBlock(block.id, $event)">
            <router-link class="threesixty__bullet-close" v-if="selectedBullet === block.id && selectedBullet !== -1" :to="{params: {selectedBullet: -1}}"></router-link>
            <h2 class="threesixty__block-title"><span v-if="block.highlighted" class="number">{{block.id + 1}}.</span> <span v-html="block.title"></span></h2>
            <div class="threesixty__block-content" v-html="block.content"></div>
          </div>
        </div>

      </div>

      <div class="threesixty__player">
        <three-sixty-player :key="tViewIndex" width="1024" height="768" :frames="frames" :bulletsJson="bulletsJson" :info="info"></three-sixty-player>
        <div class="threesixty__player-nav">
          <dropdown-menu v-if="dropdownArray.length > 1" :array="dropdownArray" :currentIndex="tViewIndex" :title="translations['productTitle']" @updateIndex="updateTViewIndex" v-model="info"></dropdown-menu>
          <toggle-button v-if="!isMobile" :label="translations['threesixtyLabels']" align="left" @change="toggleInfo" v-model="info"></toggle-button>
          <toggle-button v-if="tView.isNocanopy" :label="translations['threesixtyCanopy']" align="left" @change="toggleCanopy" v-model="canopy"></toggle-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import ThreeSixtyPlayer from '@/components/ThreeSixtyPlayer';
import ToggleButton from '@/components/ToggleButton';
import DropdownMenu from '@/components/DropdownMenu';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';
import Macy from 'macy-watchcss';
import Vue from 'vue';

const scrollToElement = require('scroll-to-element');

export default {
  name: 'threesixty',
  components: { PrevNextNav, ThreeSixtyPlayer, ToggleButton, DropdownMenu, HeaderBox, MoviePlayer },
  computed: {
    ...mapGetters(['translations', 'page', 'tViewIndex', 'canopy', 'info', 'contentBlocks', 'bulletsJson', 'frames', 'selectedBullet']),
    title() {
      return this.tView.title;
    },
    tView() {
      return this.page.threesixtyViews[this.tViewIndex];
    },
    dropdownArray() {
      const arr = [];
      [].forEach.call(this.page.threesixtyViews, (threesixtyView, index) => {
        const link = {
          title: threesixtyView.productName,
          index,
        };
        arr.push(link);
      });
      return arr;
    },
    isMobile() {
      return this.innerWidth < 700 || this.isLandscape;
    },
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      isLandscape: window.matchMedia('only screen and (min-device-width: 320px) and (max-device-width: 760px) and (orientation: landscape)').matches,
      isNotTablet: window.matchMedia('screen and (min-width: 1024px)').matches,
      macy: null,
    };
  },
  methods: {
    toggleInfo(val) {
      const params = this.$route.params;
      params.selectedBullet = -1;
      params.info = val ? 'info' : 'noinfo';

      this.$router.push({
        name: this.$route.name,
        params,
      });
    },
    toggleCanopy(val) {
      const params = this.$route.params;
      params.selectedBullet = -1;
      params.canopy = val ? 'canopy' : 'nocanopy';

      this.$router.push({
        name: this.$route.name,
        params,
      });
    },
    updateTViewIndex(index) {
      const params = this.$route.params;
      params.selectedBullet = -1;
      params.tViewIndex = index;

      this.$router.push({
        name: this.$route.name,
        params,
      });

      if (!this.tView.isNocanopy) {
        params.canopy = 'canopy';

        this.$router.push({
          name: this.$route.name,
          params,
        });
      }
    },
    goToBlock(id, ev) {
      if (!ev.target.classList.contains('threesixty__bullet-close')) {
        const params = this.$route.params;
        params.selectedBullet = id !== -1 ? id : -1;

        this.$router.push({
          name: this.$route.name,
          params,
        });
      }
    },
  },
  watch: {
    selectedBullet() {
      if (!this.isNotTablet && !this.isLandscape) {
        Vue.nextTick(() => {
          this.macy.reInit();
        });
      }
      const bullet = this.$el.querySelector('#block-' + this.selectedBullet); //eslint-disable-line
      if (this.selectedBullet !== -1 && (this.isNotTablet || this.isLandscape) && bullet) {
        scrollToElement(bullet, { duration: 500, align: 'middle' });
      }
    },
    canopy() {
      Vue.nextTick(() => {
        this.macy.reInit();
      });
    },
  },
  mounted() {
    this.macy = Macy({
      container: '.threesixty__blocks',
      trueOrder: false,
      waitForImages: false,
      margin: 20,
      columns: 2,
      breakAt: {
        699: 1,
      },
      watchCSS: true,
    });

    if (this.isMobile && this.info) {
      this.toggleInfo(false);
    }

    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth;
      this.isLandscape = window.matchMedia('only screen and (min-device-width: 320px) and (max-device-width: 760px) and (orientation: landscape)').matches;
      this.isNotTablet = window.matchMedia('screen and (min-width: 1024px)').matches;

      if (this.isMobile && this.info) {
        this.toggleInfo(false);
      }
    });

    // const vids = document.querySelectorAll('.threesixty__block-video');

    // [].forEach.call(vids, (vid) => {
      // vid.addEventListener('ended', () => {
        // vid.classList.add('hide');
      // });
    // });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.threesixty {
  @include page;

  &__header {
    width: 100%;

    @include not-tablet {
      display: none;
    }
  }

  &__innerwrap {
    @include not-laptop {
      display: flex;
      flex-direction: column-reverse;
      padding-top: 0;
      justify-content: flex-end;
    }

    @include landscape {
      padding-top: 20px;
      display: block;
    }
  }

  &__player {
    display: block;
    position: relative;
    margin: 0 0 20px;

    &::after {
      content: '';
      display: block;
      padding-top: calc(75%);
    }

    @include not-tablet {
      width: calc(66.66% - 110px);
      position: fixed;
      top: 40px;
      right: 40px;
      bottom: 70px;
      margin: 0;
    }

    @include landscape {
      position: fixed;
      width: calc(50% - 30px);
      top: 20px;
      right: 20px;
      left: calc(50% + 10px);
    }
  }

  &__player-nav {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 80px;

    @include not-laptop {
      flex-wrap: wrap;
    }

    @include landscape {
      min-height: 0;
    }
  }

  &__blocks {
    // display: flex;
    // flex-direction: column;
    overflow: visible;

    @include not-mobile {
      margin-bottom: 20px;
    }

    @include not-tablet {
      width: 33.33%;
    }

    @include tablet {
      &::after {
        content: "macy";
        display: none;
      }
    }

    @include landscape {
      width: calc(50% - 10px);
      margin: 0;

      &::after {
        content: none;
      }
    }
  }

  &__block {
    background: $c_white;
    margin-bottom: 20px;
    box-sizing: border-box;
    // order: 2;

    &--title {
      color: $c_white;
      padding: 30px;
      background: $c_primary;
      // order: 1;

      @include not-laptop {
        display: none;
      }
    }

    &.opaque {
      opacity: .5;

      @include not-laptop {
        display: none;
      }

      @include landscape {
        display: block;
      }
    }
  }

  &__title {
    @include font-title;
  }

  &__block-title {
    @include font-block-title;
    
    .number {
      color: $c_primary;

      @include mobile {
        display: none;
      }

      @include landscape {
        display: none;
      }
    }
  }

  &__block-content {
    @include font-block-content;
    line-height: 2.3333;
  }

  &__block-image-wrapper {
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  &__block-image {
    display: block;
    width: 100%;
  }

  // &__block-video {
    // width: 100%; 
    // height: 100%;
    
    /* Center the video */
    // position: absolute;
    // top: 0;
    // left: 0;
    // transition: opacity .5s;

    // &.hide {
      // opacity: 0;
      // pointer-events: none;
    // }
  // }

  &__block-textwrap {
    padding: 40px 30px;
    position: relative;
  }

  &__bullet-close {
    background: #0096C3;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: -20px;
    right: -20px;
    z-index: 1;
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.31);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.31);
    -webkit-transition: all .25s;
    transition: all .25s;

    &:before, &:after {
      content: '';
      background: #fff;
      display: block;
      height: 2px;
      left: 11px;
      position: absolute;
      top: 19px;
      transform: rotate(-45deg);
      width: 18px;
      z-index: 10;
      transition: all .25s;
    }

    &:before {
      transform: rotate(45deg);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/templates/ThreeSixty.vue